import React, { Component } from 'react';
import { Calendar, Clock, Video, Users, FileText, Plus } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Calendar as CalendarComponent } from '../ui/Calendar';
export function Meetings() {
  const upcomingMeetings = [{
    id: 1,
    title: 'المراجعة الشهرية للجنة المالية',
    committee: 'لجنة المالية',
    date: '2023-09-15',
    time: '10:00 صباحاً',
    type: 'عبر الإنترنت',
    attendees: 8
  }, {
    id: 2,
    title: 'مناقشة تحديثات سياسة الموارد البشرية',
    committee: 'لجنة الموارد البشرية',
    date: '2023-09-20',
    time: '11:30 صباحاً',
    type: 'حضوري',
    attendees: 6
  }, {
    id: 3,
    title: 'مراجعة بروتوكول أمن تكنولوجيا المعلومات',
    committee: 'لجنة تكنولوجيا المعلومات',
    date: '2023-09-10',
    time: '02:00 مساءً',
    type: 'عبر الإنترنت',
    attendees: 5
  }];
  const calendarEvents = [{
    id: 1,
    title: 'المراجعة الشهرية للجنة المالية',
    date: '2023-09-15',
    committee: 'لجنة المالية',
    type: 'عبر الإنترنت'
  }, {
    id: 2,
    title: 'مناقشة تحديثات سياسة الموارد البشرية',
    date: '2023-09-20',
    committee: 'لجنة الموارد البشرية',
    type: 'حضوري'
  }, {
    id: 3,
    title: 'مراجعة بروتوكول أمن تكنولوجيا المعلومات',
    date: '2023-09-10',
    committee: 'لجنة تكنولوجيا المعلومات',
    type: 'عبر الإنترنت'
  }, {
    id: 4,
    title: 'الاجتماع الربع سنوي للجنة المشتريات',
    date: '2023-09-25',
    committee: 'لجنة المشتريات',
    type: 'حضوري'
  }, {
    id: 5,
    title: 'مراجعة ضمان الجودة',
    date: '2023-09-18',
    committee: 'لجنة ضمان الجودة',
    type: 'عبر الإنترنت'
  }];
  const handleSelectEvent = (eventId: number) => {
    window.location.href = `/meetings/${eventId}`;
  };
  return <div dir="rtl" data-id="element-1566">
      <div className="flex justify-between items-center mb-6" data-id="element-1567">
        <h1 className="text-2xl font-bold" data-id="element-1568">الاجتماعات</h1>
        <Link to="/meetings/add" className="px-4 py-2 bg-orange-500 text-white rounded-md hover:bg-orange-600 transition-colors flex items-center" data-id="element-1569">
          <Plus size={18} className="ml-2" data-id="element-1570" />
          جدولة اجتماع
        </Link>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-1571">
        {/* Calendar View */}
        <div className="lg:col-span-2" data-id="element-1572">
          <CalendarComponent events={calendarEvents} onSelectEvent={handleSelectEvent} data-id="element-1573" />
        </div>
        {/* Upcoming Meetings */}
        <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-1574">
          <h2 className="text-lg font-semibold mb-4" data-id="element-1575">الاجتماعات القادمة</h2>
          <div className="space-y-4" data-id="element-1576">
            {upcomingMeetings.map(meeting => <div key={meeting.id} className="border border-gray-200 rounded-lg p-4" data-id="element-1577">
                <h3 className="font-medium text-gray-900" data-id="element-1578">{meeting.title}</h3>
                <p className="text-sm text-gray-500 mb-2" data-id="element-1579">
                  {meeting.committee}
                </p>
                <div className="flex items-center text-sm text-gray-500 mb-1" data-id="element-1580">
                  <Calendar size={16} className="ml-2" data-id="element-1581" />
                  {meeting.date}
                </div>
                <div className="flex items-center text-sm text-gray-500 mb-1" data-id="element-1582">
                  <Clock size={16} className="ml-2" data-id="element-1583" />
                  {meeting.time}
                </div>
                <div className="flex items-center text-sm text-gray-500 mb-1" data-id="element-1584">
                  {meeting.type === 'عبر الإنترنت' ? <Video size={16} className="ml-2" data-id="element-1585" /> : <Users size={16} className="ml-2" data-id="element-1586" />}
                  {meeting.type}
                </div>
                <div className="flex items-center text-sm text-gray-500 mb-3" data-id="element-1587">
                  <Users size={16} className="ml-2" data-id="element-1588" />
                  {meeting.attendees} حاضرين
                </div>
                <div className="flex space-x-2" data-id="element-1589">
                  <Link to={`/meetings/${meeting.id}`} className="px-3 py-1 bg-orange-500 text-white text-sm rounded" data-id="element-1590">
                    عرض التفاصيل
                  </Link>
                  <button className="px-3 py-1 bg-gray-200 text-gray-700 text-sm rounded flex items-center mr-2" data-id="element-1591">
                    <FileText size={14} className="ml-1" data-id="element-1592" />
                    جدول الأعمال
                  </button>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </div>;
}